import React from 'react';
import { motion } from 'framer-motion';
import { ExternalLinkIcon } from 'lucide-react';
export function FinalCTA() {
  return <div className="w-full min-h-screen flex items-center justify-center bg-[#FAFAF8] px-6" data-id="element-77">
      <div className="max-w-lg w-full text-center space-y-10" data-id="element-78">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} className="space-y-5" data-id="element-79">
          <h1 className="text-3xl md:text-4xl font-extrabold text-[#1C1917] leading-tight" data-id="element-80">
            Explore how different mindsets shape treatment decisions
          </h1>
          <p className="text-base text-[#57534E] max-w-md mx-auto" data-id="element-81">
            Access the full segmentation analysis and discover deeper insights
            into specialist decision-making.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.3
      }} data-id="element-82">
          <button className="inline-flex items-center gap-3 px-10 py-4 bg-[#1C1917] text-white text-lg font-bold rounded-xl hover:bg-neutral-800 transition-all shadow-lg hover:-translate-y-0.5" data-id="element-83">
            See full analysis
            <ExternalLinkIcon className="w-5 h-5" data-id="element-84" />
          </button>
        </motion.div>

        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 0.5
      }} className="grid grid-cols-3 gap-6 pt-8" data-id="element-85">
          <div className="text-center" data-id="element-86">
            <p className="text-2xl font-extrabold text-teal-600" data-id="element-87">4</p>
            <p className="text-xs text-[#57534E] font-medium mt-1" data-id="element-88">Segments</p>
          </div>
          <div className="text-center" data-id="element-89">
            <p className="text-2xl font-extrabold text-indigo-600" data-id="element-90">12</p>
            <p className="text-xs text-[#57534E] font-medium mt-1" data-id="element-91">Insights</p>
          </div>
          <div className="text-center" data-id="element-92">
            <p className="text-2xl font-extrabold text-amber-600" data-id="element-93">4</p>
            <p className="text-xs text-[#57534E] font-medium mt-1" data-id="element-94">
              Journey Maps
            </p>
          </div>
        </motion.div>

        <motion.p initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 0.7
      }} className="text-xs text-neutral-400 pt-8" data-id="element-95">
          Based on internal segmentation analysis
        </motion.p>
      </div>
    </div>;
}